import React from "react";

export default function Quote({ author, title, text }) {
  return (
    <div className="tw-flex tw-bg-purple-tint-95 tw-gap-2">
      <div className="lc-icon lc-icon-quote-filled lc-icon-md tw-text-blue" />
      <div className="tw-flex tw-bg-purple-tint-95 tw-flex-col">
        <div className="tw-flex tw-bg-purple-tint-95 tw-gap-1.5">
          <span className="tw-text-gray body-3 tw-font-bold">{author}</span>
          <span className="tw-text-teal body-3 tw-font-semibold">{title}</span>
        </div>
        <div>
          <span className="body-1">{text}</span>
        </div>
      </div>
    </div>
  );
}
